<template>
  <div class="p-24 bg-cosmos-black text-white text-xl text-center">
    <p class="mb-16">
      For best experience, open the interactive tutorial on a larger screen.
    </p>
    <p class="mb-24">
      In the meantime, learn how to build your search in 45 seconds here:
    </p>
    <a
      class="py-16 px-24 rounded-full bg-white text-sm text-telluric-blue no-underline uppercase tracking-wide"
      href="https://www.youtube.com/watch?v=IYY5RM1sBC0"
      target="_blank"
      rel="noopener"
      @click="
        track({
          message: 'Clicked Video Algolia 45 Seconds',
          code: 'docs.onboarding.open.video',
          extraData: {
            source: 'Tutorial Fallback'
          }
        })
      "
      >Watch video tutorial</a
    >
  </div>
</template>

<script>
import track from '@/scripts/Track'

export default {
  methods: { track }
}
</script>
